export enum Dashboard {
  Clinician,
  DataManagement
}

export class DashboardLayout {
  name: string;
  type: Dashboard;
  prefix: string;
}
